/**
 * Available timezones for the app.
 * Default: America/Bogota (Colombia).
 */
export const AVAILABLE_TIMEZONES = [
  { value: "America/Bogota", label: "Colombia (UTC-5)" },
  { value: "America/Mexico_City", label: "México (UTC-6)" },
  { value: "America/New_York", label: "Estados Unidos — Este (UTC-4)" },
  { value: "America/Lima", label: "Perú (UTC-5)" },
  { value: "America/Santiago", label: "Chile (UTC-4)" },
] as const;

const TIMEZONE_KEY = "nexo-timezone";
const DEFAULT_TIMEZONE = "America/Bogota";

export function getTimezone(): string {
  try {
    return localStorage.getItem(TIMEZONE_KEY) ?? DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

export function setTimezone(tz: string): void {
  try {
    localStorage.setItem(TIMEZONE_KEY, tz);
  } catch {}
}

/**
 * Formats an ISO date string in the app's configured timezone.
 * Handles both full ISO timestamps ("2026-07-15T09:28:10.226Z")
 * and date-only strings ("2026-07-15").
 */
export function formatDate(isoString: string | null | undefined): string {
  if (!isoString) return "—";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("es-CO", { timeZone: getTimezone(), day: "numeric", month: "numeric", year: "numeric" });
}

/**
 * Formats showing date + time in the app's configured timezone.
 */
export function formatDateTime(isoString: string | null | undefined): string {
  if (!isoString) return "—";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleString("es-CO", {
    timeZone: getTimezone(),
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
